import http from "../../../services/api";

export const previewInvite = async (token) => {
  try {
    const res = await http.get(`/invitations/${token}`);
    return res.data;
  } catch (err) {
    throw { ...(err?.response?.data || {}), statusCode: err?.response?.status };
  }
};

export const acceptInvite = async (token) => {
  try {
    const res = await http.post(`/users/invitations/accept`, { token });
    return res.data;
  } catch (err) {
    throw { ...(err?.response?.data || {}), statusCode: err?.response?.status };
  }
};
